import { render, staticRenderFns } from "./policyInfo.vue?vue&type=template&id=3a7c7a07&scoped=true&"
import script from "./policyInfo.vue?vue&type=script&lang=js&"
export * from "./policyInfo.vue?vue&type=script&lang=js&"
import style0 from "./policyInfo.vue?vue&type=style&index=0&id=3a7c7a07&prod&scoped=true&lang=css&"
import style1 from "./policyInfo.vue?vue&type=style&index=1&id=3a7c7a07&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7c7a07",
  null
  
)

export default component.exports